import React from "react";

export default function Corners({ className = "" }) {
  return (
    <span className={`corners ${className}`} aria-hidden="true">
      <span className="corner corner--tl" />
      <span className="corner corner--tr" />
      <span className="corner corner--bl" />
      <span className="corner corner--br" />
    </span>
  );
}
